import type { Platform } from "../types/ranking";
import { PLATFORM_METADATA, type PlatformMetadata } from "./platforms";

export function getPlatformMetadata(platform: Platform): PlatformMetadata {
  return PLATFORM_METADATA[platform];
}

export function getActivePlatforms(): PlatformMetadata[] {
  return Object.values(PLATFORM_METADATA).filter((p) => p.status === "active");
}

export function getComingSoonPlatforms(): PlatformMetadata[] {
  return Object.values(PLATFORM_METADATA).filter(
    (p) => p.status === "coming_soon",
  );
}

export function getAllPlatforms(): PlatformMetadata[] {
  return Object.values(PLATFORM_METADATA);
}

/**
 * Display names of the platforms that have a registered scraping adapter
 * and are therefore claim-worthy in marketing/legal copy. Derived from
 * `PLATFORM_METADATA.status`, so flipping a `coming_soon` flag to `active`
 * (or vice versa) automatically shifts the truth every surface reads from.
 *
 * Consumed by the marketing-copy regression test in `apps/web/lib/marketing`
 * that fails if any user-facing prose names a `coming_soon` platform.
 */
export const ACTIVE_PLATFORM_NAMES: readonly string[] = Object.values(
  PLATFORM_METADATA,
)
  .filter((p) => p.status === "active")
  .map((p) => p.displayName);

/**
 * Display names of the platforms that are advertised as "coming soon".
 * A `coming_soon` platform must not appear in any logged-out marketing
 * surface or legal page — the assertion lives in the test above.
 */
export const COMING_SOON_PLATFORM_NAMES: readonly string[] = Object.values(
  PLATFORM_METADATA,
)
  .filter((p) => p.status === "coming_soon")
  .map((p) => p.displayName);


